import { Provider as ReactReduxProvider } from "react-redux";
import { ThemeProvider as MUIThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { Amplify } from "aws-amplify";
import ReactGA from "react-ga4";

import GlobalRouter from "./GlobalRouter";
import store from "./Services/Redux/reducers";
import { MUITheme } from "./Assets/MUITheme";
import DefaultHelmet from "./Services/Helmet";
import { aws_config } from "./Services/AWS/aws_config";
import GlobalLoader from "./Components/GlobalLoader";
import initQuantcast from "shared/dist/scripts/quantcast";
import initHotjar from "shared/dist/scripts/hotjar";
import FeedbackFormContainer from "./Components/FeedbackFormModal";
import CssBaseline from "@mui/material/CssBaseline";

Amplify.configure(aws_config);

initQuantcast();
if (process.env.REACT_APP_GA_TRACKING_ID) {
    ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
}
if (process.env.REACT_APP_HOTJAR_ID && process.env.REACT_APP_HOTJAR_SV) {
    initHotjar(process.env.REACT_APP_HOTJAR_ID, process.env.REACT_APP_HOTJAR_SV);
}

function App() {
    return (
        <ReactReduxProvider store={store}>
            <StyledEngineProvider injectFirst>
                <MUIThemeProvider theme={MUITheme}>
                    <CssBaseline enableColorScheme />
                    <DefaultHelmet />
                    <GlobalRouter />
                    <GlobalLoader />
                    <FeedbackFormContainer />
                </MUIThemeProvider>
            </StyledEngineProvider>
        </ReactReduxProvider>
    );
}

export default App;
